"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function Switch(_a) {
    var id = _a.id, baseColor = _a.baseColor, error = _a.error, style = _a.style, className = _a.className, props = __rest(_a, ["id", "baseColor", "error", "style", "className"]);
    return (react_1.default.createElement(styles_1.SwitchContainer, { style: style === null || style === void 0 ? void 0 : style.root, className: className === null || className === void 0 ? void 0 : className.root },
        react_1.default.createElement(styles_1.SwitchInput, __assign({ id: id, type: "checkbox", baseColor: baseColor, style: style === null || style === void 0 ? void 0 : style.input, className: className === null || className === void 0 ? void 0 : className.input }, props)),
        react_1.default.createElement(styles_1.SwitchLabel, { htmlFor: id, style: style === null || style === void 0 ? void 0 : style.label, className: className === null || className === void 0 ? void 0 : className.label }),
        error && (react_1.default.createElement(styles_1.SwitchErrorParagraph, { style: style === null || style === void 0 ? void 0 : style.error, className: className === null || className === void 0 ? void 0 : className.error }, error))));
}
exports.default = Switch;
//# sourceMappingURL=index.js.map